// extracted by mini-css-extract-plugin
module.exports = {"page":"container-module--page--2uR0J"};